"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importStar(require("vue-class-component"));
var VModal_vue_1 = __importDefault(require("../scraps/VModal.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var FirstNameInput_vue_1 = __importDefault(require("../form/FirstNameInput.vue"));
var LastNameInput_vue_1 = __importDefault(require("../form/LastNameInput.vue"));
var RegistrationNumberInput_vue_1 = __importDefault(require("../form/RegistrationNumberInput.vue"));
var JoinedAtInput_vue_1 = __importDefault(require("../form/JoinedAtInput.vue"));
var QuitAtInput_vue_1 = __importDefault(require("../form/QuitAtInput.vue"));
var InputErrorMixin_1 = __importDefault(require("../../mixins/InputErrorMixin"));
var errors_1 = __importDefault(require("../../config/errors"));
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
var UnitSelect_vue_1 = __importDefault(require("../form/UnitSelect.vue"));
var event_bus_1 = require("../../event-bus");
var CreateScoutModal = /** @class */ (function (_super) {
    __extends(CreateScoutModal, _super);
    function CreateScoutModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "create-scout-modal";
        _this.errors = errors_1.default;
        _this.firstName = "";
        _this.lastName = "";
        _this.registrationNumber = "";
        _this.joinedAt = "";
        _this.quitAt = "";
        _this.currentDistrict = {};
        _this.currentUnit = {};
        return _this;
    }
    CreateScoutModal.prototype.onCurrentDistrictChanged = function () {
        this.currentUnit = {};
    };
    CreateScoutModal.prototype.reset = function () {
        this.firstName = "";
        this.lastName = "";
        this.registrationNumber = "";
        this.joinedAt = "";
        this.quitAt = "";
        this.currentUnit = {};
        this.currentDistrict = {};
        this.resetInputErrors();
    };
    CreateScoutModal.prototype.onCreateScout = function () {
        if (!this.inputsValid()) {
            return;
        }
        event_bus_1.EventBus.$emit(event_bus_1.events.scout.create, {
            first_name: this.firstName,
            last_name: this.lastName,
            registration_number: this.registrationNumber,
            unit_id: this.currentUnit.id,
            joined_at: this.joinedAt,
            quit_at: this.quitAt
        });
        this.reset();
        this.onClose();
    };
    CreateScoutModal.prototype.onCurrentDistrictChange = function (option) {
        this.currentDistrict = {
            id: option.value,
            name: option.name
        };
    };
    CreateScoutModal.prototype.onCurrentUnitChange = function (option) {
        this.currentUnit = {
            id: option.value,
            name: option.name
        };
    };
    CreateScoutModal.prototype.onClose = function () {
        this.reset();
        this.$emit("close");
    };
    CreateScoutModal.prototype.inputsValid = function () {
        for (var _i = 0, _a = ["firstName", "lastName", "registrationNumber", "joinedAt", "quitAt"]; _i < _a.length; _i++) {
            var ref = _a[_i];
            if (!this.$refs[ref].isValid(true)) {
                this.$refs[ref].appendValidationClass();
                return false;
            }
        }
        if (!this.currentDistrict || !this.currentDistrict.id || this.currentDistrict.id === 0) {
            this.setInputError("currentDistrict", errors_1.default.scout.invalidCurrentDistrict);
            return false;
        }
        if (!this.currentUnit || !this.currentUnit.id || this.currentUnit.id === 0) {
            this.setInputError("currentUnit", errors_1.default.scout.invalidCurrentUnit);
            return false;
        }
        return true;
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], CreateScoutModal.prototype, "show", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], CreateScoutModal.prototype, "districts", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], CreateScoutModal.prototype, "units", void 0);
    __decorate([
        vue_property_decorator_1.Watch("currentDistrict")
    ], CreateScoutModal.prototype, "onCurrentDistrictChanged", null);
    CreateScoutModal = __decorate([
        vue_class_component_1.default({ components: {
                UnitSelect: UnitSelect_vue_1.default,
                DistrictSelect: DistrictSelect_vue_1.default,
                VModal: VModal_vue_1.default,
                VButton: VButton_vue_1.default,
                FirstNameInput: FirstNameInput_vue_1.default,
                LastNameInput: LastNameInput_vue_1.default,
                RegistrationNumberInput: RegistrationNumberInput_vue_1.default,
                JoinedAtInput: JoinedAtInput_vue_1.default,
                QuitAtInput: QuitAtInput_vue_1.default
            } })
    ], CreateScoutModal);
    return CreateScoutModal;
}(vue_class_component_1.mixins(InputErrorMixin_1.default)));
exports.default = CreateScoutModal;
